window.events = new Vue();


window.events.fire = window.events.$emit;

window.events.listen = window.events.$on;

window.bus = new Vue();


window.bus.fire = window.events.$emit;

window.bus.listen = window.events.$on;




// WEBPACK FOOTER //
// ./src/components/Core/event-api.js